<template>
  <div>
    <a-form :form="form" @submit="addRole">
      <a-col :span="24">
        <a-form-item>
          <h4 class="text-opacity">Name of Role</h4>
          <a-input
            v-decorator="['name', {initialValue: role.name, rules: [{ required: true, message: 'Please enter the name of this role' }] }]"
            class="custom-input"
            placeholder="What is the Name of this role"
          />
        </a-form-item>
      </a-col>
      <a-col :span="24">
        <a-form-item>
          <h4 class="text-opacity">
            Role Status
            <sup>optional</sup>
          </h4>
          <a-select
            v-decorator="[
            'status',
            {initialValue: role.active ? role.active : 1, rules: [{ required: true, message: 'Please select a status' }] },
            ]"
            placeholder="Set Status for role"
          >
            <a-select-option :value="1">
              <a-badge status="success"/>Active
            </a-select-option>
            <a-select-option :value="0">
              <a-badge status="error"/>InActive
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="24">
        <a-form-item>
          <h4 class="text-opacity">
            Role Description
            <sup>optional</sup>
          </h4>
          <a-textarea
            v-decorator="['description', {initialValue: role.description, rules: [{ message: 'Please enter role description' }] }]"
            placeholder="What is this role about"
            :autosize="{ minRows: 2, maxRows: 12 }"
          />
        </a-form-item>
      </a-col>
      <a-col :span="24">
        <div class="ant-modal-footer" style="padding-right:0">
          <div>
            <button @click="onCancel" type="button" class="ant-btn">
              <span>Cancel</span>
            </button>
            <button type="submit" class="ant-btn ant-btn-primary">
              <span>Create</span>
            </button>
          </div>
        </div>
      </a-col>
    </a-form>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  data() {
    return {
      visible: true,
      form: this.$form.createForm(this, { name: "coordinated" })
    };
  },
  props: ["role"],
  methods: {
    showModal() {
      this.visible = true;
    },
    addRole(e) {
      // this.visible = false;
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const hide = this.$message.loading(
            "Saving your Entry. Please one minute"
          );
          let data = {
            id: this.role && this.role.id,
            name: values.name,
            description: values.description,
            active: values.status
          };

          this.$store
            .dispatch("addRole", data)
            .then(s => {
              if (s) {
                setTimeout(hide, 20);
                this.$message.success("🔏 Role Successfully Saved");
                return this.$router.push({ name: "roles" });
              }
            })
            .catch(err => {
              if (err.status === 422) {
                setTimeout(hide, 20);
                Object.values(err.data).forEach(s => {
                  this.$message.error("Sorry, " + s, 2.5);
                });
              }
            });
        }
      });
    },
    onCancel(e) {
      return this.$router.push({ name: "roles" });
    }
  },
  mounted() {}
};
</script>
